import { render, staticRenderFns } from "./Entry-Account-UsernameDialog.vue?vue&type=template&id=2e35a5e0&scoped=true&"
import script from "./Entry-Account-UsernameDialog.vue?vue&type=script&lang=js&"
export * from "./Entry-Account-UsernameDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e35a5e0",
  null
  
)

export default component.exports